import { msToMMSS } from '~/js/utilities';

const videoLibraryItem = (videoBlock) => ({
  videoBlock: {
    ...videoBlock.video,
    title: videoBlock.title,
  },

  selectVideo(playOnLoad) {
    this.$dispatch('select-video', { videoBlock: this.videoBlock, playOnLoad });
  },

  get isSelected() {
    return this.videoBlock.id === this.selectedVideoBlock.id;
  },

  get duration() {
    const ms = this.videoBlock.duration;
    return msToMMSS(ms);
  },
});

export default videoLibraryItem;
